import { PageContainer, PageContainerProps } from '@ant-design/pro-components';
import { useEffect } from 'react';
import { useModel } from '@umijs/max';
import Icon from '../Icon';

type BasePageContainerProps = {
    showFullScreenBtn?: boolean;
    onFullScreenChange?: (isFullScreen: boolean) => void;
} & PageContainerProps;

const BasePageContainer: React.FC<BasePageContainerProps> = ({
    showFullScreenBtn = true,
    onFullScreenChange,
    ...props
}) => {
    const { isFullScreen, setIsFullScreen } = useModel('global');

    const headerDisplays: string[] = [];

    useEffect(() => {
        if (isFullScreen) {
            hideLayout();
        } else {
            showLayout();
        }
    }, [isFullScreen]);

    const hideLayout = () => {
        const layoutContainer = document.querySelector(
            '.ant-layout.ant-layout-has-sider',
        );
        const layoutHeaders = document.querySelectorAll('.ant-layout-header');
        const layoutSiders = document.querySelector('.ant-layout-sider');
        console.log(layoutHeaders);
        if (layoutHeaders.length) {
            layoutHeaders.forEach((item, index) => {
                console.log(item.style.display);
                headerDisplays[index] = item.style.display;
                item.style.display = 'none';
            });
        }

        console.log('layoutSiders==', layoutSiders);
        if (layoutSiders) {
            layoutSiders.style.display = 'none';
        }

        if (layoutContainer?.firstChild?.style?.width) {
            layoutContainer.firstChild.style.display = 'none';
        }
    };
    const showLayout = () => {
        const layoutContainer = document.querySelector(
            '.ant-layout.ant-layout-has-sider',
        );
        const layoutHeaders = document.querySelectorAll('.ant-layout-header');
        const layoutSiders = document.querySelector('.ant-layout-sider');
        console.log(
            'layoutContainer===',
            layoutContainer?.firstChild?.style?.width,
        );
        if (layoutHeaders.length) {
            layoutHeaders.forEach((item, index) => {
                item.style.display = headerDisplays[index] || 'flex';
            });
        }
        if (layoutSiders) {
            layoutSiders.style.display = 'block';
        }
        if (layoutContainer?.firstChild?.style?.width) {
            layoutContainer.firstChild.style.display = 'block';
        }
    };
    const onFullScreenClick = () => {
        onFullScreenChange?.(!isFullScreen);
        setIsFullScreen(!isFullScreen);
    };

    return (
        <PageContainer
            header={{
                breadcrumb: {},
                title: null,
            }}
            className="test_page_container"
            {...props}
            // style={{ height: isFullScreen ? '100%' : 'calc(100vh - 56px)' }}
        >
            {showFullScreenBtn && (
                <div
                    className="fullscreen_btn"
                    onClick={onFullScreenClick}
                >
                    {!isFullScreen && <Icon type="icon-quanping1"></Icon>}
                    {isFullScreen && <Icon type="icon-quxiaoquanping1"></Icon>}
                </div>
            )}

            {props.children}
        </PageContainer>
    );
};

export default BasePageContainer;
